import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
    selector: 'lib-filter-pill',
    imports: [
        NgIf
    ],
    templateUrl: './filter-pill.component.html',
    styleUrl: './filter-pill.component.scss'
})
export class FilterPillComponent {
    @Input() label!: string;
    @Input() clearable = false;
    @Output() clear = new EventEmitter<void>();

    onClear() {
        this.clear.emit();
    }
}
